import {
  actualizarEscuela,
  crearEscuela,
  eliminarEscuela,
  getEscuelas,
} from 'api/escuela'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import swal from 'sweetalert2'

const key = 'escuelas'
export function useObtenerEscuela(buscar) {
  return useQuery(key, () => getEscuelas(buscar))
}

export function useCrearEscuela() {
  const queryClient = useQueryClient()
  return useMutation(crearEscuela, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarEscuela() {
  const queryClient = useQueryClient()
  return useMutation(actualizarEscuela, {
    onSuccess: (_, value) => {
      const { id, values: escuelaActualizado } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((escuela) => {
          let nuevoEscuela = escuela
          if (id === escuela.id) {
            nuevoEscuela = escuelaActualizado
          }
          return nuevoEscuela
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarEscuela() {
  const queryClient = useQueryClient()
  return useMutation(eliminarEscuela, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (escuela) => escuela.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useEscuela(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarEscuela } = useEliminarEscuela()
  const { mutateAsync: actualizarEscuela } = useActualizarEscuela()
  const { mutateAsync: crearEscuela } = useCrearEscuela()

  const handleCrearEscuela = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearEscuela(values)
      const message = `La escuela ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarEscuela = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarEscuela({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La escuela fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarEscuela = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarEscuela(id)
          const message = `La escuela ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarEscuela = async (value) => {
    queryClient.prefetchQuery(key, () => getEscuelas(value))
  }

  return {
    obtenerEscuelas: useObtenerEscuela,
    handleEliminarEscuela,
    handleActualizarEscuela,
    handleCrearEscuela,
    handleBuscarEscuela,
  }
}
